// Centralised data-testid map for Ata House
export const HOME = {
  emergentLink: "emergent-link",
};

export const NAV = {
  root: "site-nav",
  logo: "nav-logo",
  bookCta: "nav-book-cta",
  link: (key) => `nav-link-${key}`,
};

export const HERO = {
  root: "hero",
  cta: "hero-book-cta",
};

export const BOOKING = {
  section: "booking-section",
  calendar: "booking-calendar",
  name: "booking-name",
  email: "booking-email",
  phone: "booking-phone",
  guests: "booking-guests",
  message: "booking-message",
  submit: "booking-submit",
  total: "booking-total",
  success: "booking-success",
  checkin: "booking-checkin",
  checkout: "booking-checkout",
  clearDates: "booking-clear-dates",
};

export const GALLERY = {
  root: "gallery",
  tile: (i) => `gallery-tile-${i}`,
  lightbox: "gallery-lightbox",
  lightboxClose: "gallery-lightbox-close",
  lightboxNext: "gallery-lightbox-next",
  lightboxPrev: "gallery-lightbox-prev",
};

export const ADMIN = {
  loginEmail: "admin-login-email",
  loginPassword: "admin-login-password",
  loginSubmit: "admin-login-submit",
  logout: "admin-logout",
  rateInput: "admin-rate-input",
  rateSave: "admin-rate-save",
  blockedStart: "admin-blocked-start",
  blockedEnd: "admin-blocked-end",
  blockedReason: "admin-blocked-reason",
  blockedAdd: "admin-blocked-add",
  blockedRemove: (id) => `admin-blocked-remove-${id}`,
  bookingApprove: (id) => `admin-booking-approve-${id}`,
  bookingDecline: (id) => `admin-booking-decline-${id}`,
  bookingDelete: (id) => `admin-booking-delete-${id}`,
};
